'use strict';

import { Socket } from "./network/Socket";
import * as HttpApi from "./network/HttpApi";
import * as Utils from "./utils/utils";
import * as i8n from "./utils/i8n";

window.HttpApi = HttpApi
window.Socket = Socket;
window.Utils = Utils;
window.i8n = i8n;

